"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Buffer_1 = require("./Buffer");

var EventEmitter_1 = require("./common/EventEmitter");

var BufferSet = function (_super) {
  __extends(BufferSet, _super);

  function BufferSet(_terminal) {
    var _this = _super.call(this) || this;

    _this._terminal = _terminal;
    _this._normal = new Buffer_1.Buffer(_this._terminal, true);

    _this._normal.fillViewportRows();

    _this._alt = new Buffer_1.Buffer(_this._terminal, false);
    _this._activeBuffer = _this._normal;

    _this.setupTabStops();

    return _this;
  }

  Object.defineProperty(BufferSet.prototype, "alt", {
    get: function get() {
      return this._alt;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BufferSet.prototype, "active", {
    get: function get() {
      return this._activeBuffer;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BufferSet.prototype, "normal", {
    get: function get() {
      return this._normal;
    },
    enumerable: true,
    configurable: true
  });

  BufferSet.prototype.activateNormalBuffer = function () {
    if (this._activeBuffer === this._normal) {
      return;
    }

    this._alt.clear();

    this._activeBuffer = this._normal;
    this.emit('activate', {
      activeBuffer: this._normal,
      inactiveBuffer: this._alt
    });
  };

  BufferSet.prototype.activateAltBuffer = function () {
    if (this._activeBuffer === this._alt) {
      return;
    }

    this._alt.fillViewportRows();

    this._activeBuffer = this._alt;
    this.emit('activate', {
      activeBuffer: this._alt,
      inactiveBuffer: this._normal
    });
  };

  BufferSet.prototype.resize = function (newCols, newRows) {
    this._normal.resize(newCols, newRows);

    this._alt.resize(newCols, newRows);
  };

  BufferSet.prototype.setupTabStops = function (i) {
    this._normal.setupTabStops(i);

    this._alt.setupTabStops(i);
  };

  return BufferSet;
}(EventEmitter_1.EventEmitter);

exports.BufferSet = BufferSet;